import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "picker", "preview"]
  
  connect() {
    // 初期値を同期
    if (this.hasInputTarget && this.hasPickerTarget) {
      this.pickerTarget.value = this.inputTarget.value || "#FFFFFF"
    }
  }
  
  updateColor(event) {
    const color = event.target.value
    
    // HEXカラーの形式をチェック
    if (this.isValidHexColor(color)) {
      this.updatePreview(color)
      
      // ピッカーも更新
      if (this.hasPickerTarget) {
        this.pickerTarget.value = color
      }
    }
  }
  
  updateFromPicker(event) {
    const color = event.target.value
    
    // テキストフィールドを更新
    if (this.hasInputTarget) {
      this.inputTarget.value = color.toUpperCase()
    }
    
    this.updatePreview(color)
  }
  
  updatePreview(color) {
    if (!this.hasPreviewTarget) return
    
    const colorType = this.previewTarget.dataset.colorType
    
    if (colorType === "border") {
      // 境界線色の場合
      this.previewTarget.style.borderColor = color
    } else if (this.previewTarget.querySelector("span")) {
      // 文字色の場合（Aaテキストがある）
      this.previewTarget.style.backgroundColor = color
      const textSpan = this.previewTarget.querySelector("span")
      textSpan.style.color = color
    } else {
      // 背景色の場合
      this.previewTarget.style.backgroundColor = color
    }
  }
  
  isValidHexColor(color) {
    return /^#[0-9A-F]{6}$/i.test(color)
  }
}